<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="productGroupsPurchaseFlow"
        >
          <span class="fs-3">{{
            'configurationOptionModule.productGroupsPurchaseFlow' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsed"
      class="card-body pt-0"
      id="productGroupsPurchaseFlow"
    >
      <div class="nav nav-segment my-2">
        <button
          type="button"
          (click)="$event.preventDefault(); setFormValues()"
          class="nav-segment nav-link"
          [ngClass]="!cfIsSelected ? ' active' : ''"
        >
          {{
            'configurationOptionModule.apProductGroupPurchaseFlow' | translate
          }}
        </button>

        <button
          type="button"
          (click)="$event.preventDefault(); setFormValues()"
          class="nav-segment nav-link"
          [ngClass]="cfIsSelected ? ' active' : ''"
        >
          {{
            'configurationOptionModule.cfProductGroupPurchaseFlow' | translate
          }}
        </button>
      </div>
      <div class="card-table">
        <table class="table border-bottom table-light align-top table-sm">
          <thead>
            <tr>
              <th scope="col">
                {{ 'configurationOptionModule.ordinal' | translate }}<br />
              </th>
              <!--              <th scope='col'>-->
              <!--                {{ 'productGroupModule.productGroup' | translate }}-->
              <!--                {{ 'general.type' | translate }}<br />-->
              <!--              </th>-->
              <th scope="col">
                {{ 'productGroupModule.productGroups' | translate }}
                <br />
              </th>
              <th scope="col" *ngIf="availableLanguages['nl']">
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-nl ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                ></span>
              </th>
              <th scope="col" *ngIf="availableLanguages['en']">
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-en ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                ></span>
              </th>
              <th scope="col" *ngIf="availableLanguages['fr']">
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-fr ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                ></span>
              </th>
              <th scope="col" *ngIf="availableLanguages['de']">
                {{ 'general.title' | translate }}
                <span
                  class="flag flag-de ms-2"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                ></span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr formGroupName="datesGroups">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  formControlName="ordinal"
                  [attr.aria-invalid]="
                    dateGroupsForm.controls.ordinal.dirty &&
                    dateGroupsForm.controls.ordinal.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    dateGroupsForm.controls.ordinal.dirty &&
                    dateGroupsForm.controls.ordinal.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td></td>
              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_nl"
                  formControlName="title_nl"
                  [attr.aria-invalid]="
                    dateGroupsForm.controls.title_nl.dirty &&
                    dateGroupsForm.controls.title_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    dateGroupsForm.controls.title_nl.dirty &&
                    dateGroupsForm.controls.title_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_en"
                  formControlName="title_en"
                  [attr.aria-invalid]="
                    dateGroupsForm.controls.title_en.dirty &&
                    dateGroupsForm.controls.title_en.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    dateGroupsForm.controls.title_en.dirty &&
                    dateGroupsForm.controls.title_en.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_fr"
                  formControlName="title_fr"
                  [attr.aria-invalid]="
                    dateGroupsForm.controls.title_fr.dirty &&
                    dateGroupsForm.controls.title_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    dateGroupsForm.controls.title_fr.dirty &&
                    dateGroupsForm.controls.title_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_de"
                  formControlName="title_de"
                  [attr.aria-invalid]="
                    dateGroupsForm.controls.title_de.dirty &&
                    dateGroupsForm.controls.title_de.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    dateGroupsForm.controls.title_de.dirty &&
                    dateGroupsForm.controls.title_de.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
            </tr>
            <tr formGroupName="rooms">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  formControlName="ordinal"
                  [attr.aria-invalid]="
                    roomsForm.controls.ordinal.dirty &&
                    roomsForm.controls.ordinal.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    roomsForm.controls.ordinal.dirty &&
                    roomsForm.controls.ordinal.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>

              <!--              <td>-->
              <!--                <input-->
              <!--                  type='number'-->
              <!--                  class='form-control'-->
              <!--                  placeholder='1'-->
              <!--                  formControlName='productGroupType'-->
              <!--                />-->
              <!--              </td>-->
              <td>
                <ng-select
                  *ngIf="allowAsLinkedProducts$ | async"
                  class="d-block mb-2"
                  [items]="allowAsLinkedProducts$ | async"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchable]="true"
                  formControlName="productIds"
                  bindLabel="description"
                  bindValue="id"
                  placeholder="{{ 'general.select' | translate }}"
                  [clearSearchOnAdd]="true"
                  [attr.aria-invalid]="
                    roomsForm.controls.productIds.dirty &&
                    roomsForm.controls.productIds.invalid
                      ? 'true'
                      : null
                  "
                >
                </ng-select>
                <app-error-message
                  *ngIf="
                    roomsForm.controls.productIds.dirty &&
                    roomsForm.controls.productIds.invalid
                  "
                ></app-error-message>
                <div [formGroup]="roomsCategoriesForm">
                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.kids' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="kids"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.adults' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="adults"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.profs' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="profs"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.commercials' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="commercials"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
              </td>

              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_nl"
                  formControlName="title_nl"
                  [attr.aria-invalid]="
                    roomsForm.controls.title_nl.dirty &&
                    roomsForm.controls.title_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    roomsForm.controls.title_nl.dirty &&
                    roomsForm.controls.title_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_en"
                  formControlName="title_en"
                  [attr.aria-invalid]="
                    roomsForm.controls.title_en.dirty &&
                    roomsForm.controls.title_en.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    roomsForm.controls.title_en.dirty &&
                    roomsForm.controls.title_en.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_fr"
                  formControlName="title_fr"
                  [attr.aria-invalid]="
                    roomsForm.controls.title_fr.dirty &&
                    roomsForm.controls.title_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    roomsForm.controls.title_fr.dirty &&
                    roomsForm.controls.title_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_de"
                  formControlName="title_de"
                  [attr.aria-invalid]="
                    roomsForm.controls.title_de.dirty &&
                    roomsForm.controls.title_de.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    roomsForm.controls.title_de.dirty &&
                    roomsForm.controls.title_de.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
            </tr>
            <tr formGroupName="facilities">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  formControlName="ordinal"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.ordinal.dirty &&
                    facilitiesForm.controls.ordinal.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    facilitiesForm.controls.ordinal.dirty &&
                    facilitiesForm.controls.ordinal.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>

              <!--              <td>-->
              <!--                <input-->
              <!--                  type='number'-->
              <!--                  class='form-control'-->
              <!--                  placeholder='1'-->
              <!--                  formControlName='productGroupType'-->
              <!--                />-->
              <!--              </td>-->
              <td>
                <ng-select
                  *ngIf="allowAsLinkedProducts$ | async"
                  class="d-block mb-2"
                  [items]="allowAsLinkedProducts$ | async"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchable]="true"
                  formControlName="productIds"
                  bindLabel="description"
                  bindValue="id"
                  placeholder="{{ 'tagModule.selectTag' | translate }}"
                  [clearSearchOnAdd]="true"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.productIds.dirty &&
                    facilitiesForm.controls.productIds.invalid
                      ? 'true'
                      : null
                  "
                >
                </ng-select>
                <app-error-message
                  *ngIf="
                    facilitiesForm.controls.productIds.dirty &&
                    facilitiesForm.controls.productIds.invalid
                  "
                ></app-error-message>
                <div [formGroup]="facilitiesCategoriesForm">
                  <div class="row gx-2 mb-2 mb-lg-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.kids' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="kids"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.adults' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="adults"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.profs' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="profs"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2">
                    <span class="col-lg-4 col-form-label">
                      {{ 'saleModule.commercials' | translate }}
                    </span>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="commercials"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.externalMultiDay' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="externalMultiDay"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.externalSingleDay' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="externalSingleDay"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.internalMultiDay' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="internalMultiDay"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2 mb-lg-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.internalSingleDay' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="internalSingleDay"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
              </td>

              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_nl"
                  formControlName="title_nl"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.title_nl.dirty &&
                    facilitiesForm.controls.title_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    facilitiesForm.controls.title_nl.dirty &&
                    facilitiesForm.controls.title_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_en"
                  formControlName="title_en"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.title_en.dirty &&
                    facilitiesForm.controls.title_en.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    facilitiesForm.controls.title_en.dirty &&
                    facilitiesForm.controls.title_en.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_fr"
                  formControlName="title_fr"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.title_fr.dirty &&
                    facilitiesForm.controls.title_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    facilitiesForm.controls.title_fr.dirty &&
                    facilitiesForm.controls.title_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_de"
                  formControlName="title_de"
                  [attr.aria-invalid]="
                    facilitiesForm.controls.title_de.dirty &&
                    facilitiesForm.controls.title_de.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    facilitiesForm.controls.title_de.dirty &&
                    facilitiesForm.controls.title_de.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
            </tr>
            <tr formGroupName="catering">
              <td>
                <input
                  type="number"
                  class="form-control"
                  placeholder="1"
                  formControlName="ordinal"
                  [attr.aria-invalid]="
                    cateringForm.controls.ordinal.dirty &&
                    cateringForm.controls.ordinal.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    cateringForm.controls.ordinal.dirty &&
                    cateringForm.controls.ordinal.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>

              <!--              <td>-->
              <!--                <input-->
              <!--                  type='number'-->
              <!--                  class='form-control'-->
              <!--                  placeholder='1'-->
              <!--                  formControlName='productGroupType'-->
              <!--                />-->
              <!--              </td>-->
              <td>
                <ng-select
                  *ngIf="products$ | async"
                  class="d-block mb-2"
                  [items]="products$ | async"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [searchable]="true"
                  formControlName="productIds"
                  bindLabel="description"
                  bindValue="id"
                  placeholder="{{ 'tagModule.selectTag' | translate }}"
                  [clearSearchOnAdd]="true"
                  [attr.aria-invalid]="
                    cateringForm.controls.productIds.dirty &&
                    cateringForm.controls.productIds.invalid
                      ? 'true'
                      : null
                  "
                >
                </ng-select>
                <app-error-message
                  *ngIf="
                    cateringForm.controls.productIds.dirty &&
                    cateringForm.controls.productIds.invalid
                  "
                ></app-error-message>
                <div [formGroup]="cateringCategoriesForm">
                  <div class="row gx-2 mb-2">
                    <span class="col-lg-4 col-form-label">
                      {{ 'saleModule.kids' | translate }}
                    </span>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="kids"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.adults' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="adults"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>

                  <div class="row gx-2 mb-2 mb-lg-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.profs' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="profs"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                  <div class="row gx-2 mb-2 mb-lg-2">
                    <label class="col-lg-4 col-form-label">
                      {{ 'saleModule.commercials' | translate }}
                    </label>
                    <div class="col-lg-8">
                      <ng-select
                        *ngIf="allowAsLinkedProducts$ | async"
                        class="d-block"
                        [items]="allowAsLinkedProducts$ | async"
                        [multiple]="true"
                        [closeOnSelect]="false"
                        [searchable]="true"
                        formControlName="commercials"
                        bindLabel="description"
                        bindValue="id"
                        [clearSearchOnAdd]="true"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
              </td>

              <td *ngIf="availableLanguages['nl']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_nl"
                  formControlName="title_nl"
                  [attr.aria-invalid]="
                    cateringForm.controls.title_nl.dirty &&
                    cateringForm.controls.title_nl.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    cateringForm.controls.title_nl.dirty &&
                    cateringForm.controls.title_nl.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['en']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_en"
                  formControlName="title_en"
                  [attr.aria-invalid]="
                    cateringForm.controls.title_en.dirty &&
                    cateringForm.controls.title_en.invalid
                      ? 'true'
                      : null
                  "
                />
                <app-error-message
                  *ngIf="
                    cateringForm.controls.title_en.dirty &&
                    cateringForm.controls.title_en.invalid
                  "
                  [message]="
                    ('general.value' | translate) +
                    ' ' +
                    ('general.isInvalid' | translate)
                  "
                ></app-error-message>
              </td>
              <td *ngIf="availableLanguages['fr']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_fr"
                  formControlName="title_fr"
                  [attr.aria-invalid]="
                    cateringForm.controls.title_fr.dirty &&
                    cateringForm.controls.title_fr.invalid
                      ? 'true'
                      : null
                  "
                />

                <p
                  class="invalid-feedback"
                  role="alert"
                  aria-atomic="true"
                  *ngIf="
                    cateringForm.controls.title_fr.dirty &&
                    cateringForm.controls.title_fr.invalid
                  "
                >
                  <i
                    role="img"
                    class="fas fa-exclamation-circle"
                    aria-hidden="true"
                  ></i>
                  {{ 'general.value' | translate }}
                  {{ 'general.isInvalid' | translate }}
                </p>
              </td>
              <td *ngIf="availableLanguages['de']">
                <input
                  type="text"
                  class="form-control"
                  placeholder="title_de"
                  formControlName="title_de"
                  [attr.aria-invalid]="
                    cateringForm.controls.title_de.dirty &&
                    cateringForm.controls.title_de.invalid
                      ? 'true'
                      : null
                  "
                />
                <app-error-message
                  *ngIf="
                    cateringForm.controls.title_de.dirty &&
                    cateringForm.controls.title_de.invalid
                  "
                  [message]="
                    ('general.value' | translate) +
                    ' ' +
                    ('general.isInvalid' | translate)
                  "
                ></app-error-message>
              </td>
            </tr>
            <tr formGroupName="noteMandatory">
              <td colspan="1">
                <!-- <input
                    type="number"
                    class="form-control"
                    placeholder="1"
                    formControlName="ordinal"
                    [attr.aria-invalid]="noteMandatoryForm.controls.ordinal.dirty &&
                        noteMandatoryForm.controls.ordinal.invalid ? 'true' : null"                  />

                  <p
                    class="invalid-feedback" role="alert" aria-atomic="true"
                    *ngIf="
                      noteMandatoryForm.controls.ordinal.dirty &&
                      noteMandatoryForm.controls.ordinal.invalid
                    "
                  >
                    <i role="img" class="fas fa-exclamation-circle" aria-hidden="true"></i>
                    {{ 'general.value' | translate }}
                    {{ 'general.isInvalid' | translate }}
                  </p> -->
              </td>

              <td colspan="5">
                <fieldset
                  ><legend> {{ 'general.noteMandatory' | translate }}</legend>
                  <div class="btn-group-segment">
                    <input
                      type="radio"
                      class="btn-check"
                      name="isMandatory"
                      value="{{ true }}"
                      (click)="patchValueForm('isMandatory', true)"
                      id="isMandatorybtnradio1"
                      autocomplete="off"
                      [checked]="noteMandatoryForm.value.isMandatory"
                    />
                    <label class="btn" for="isMandatorybtnradio1">
                      {{ 'general.yes' | translate }}
                    </label>

                    <input
                      type="radio"
                      class="btn-check"
                      name="isMandatory"
                      id="isMandatorybtnradio2"
                      (click)="patchValueForm('isMandatory', false)"
                      value="{{ false }}"
                      autocomplete="off"
                      [checked]="!noteMandatoryForm.value.isMandatory"
                    />
                    <label class="btn" for="isMandatorybtnradio2">
                      {{ 'general.no' | translate }}
                    </label>
                  </div>
                </fieldset>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
